import { Component, OnInit } from "@angular/core";
import { RegisteredUserService } from "@app/api/api";
import { ToastrService } from "ngx-toastr";
import { MatDialog } from "@angular/material";
import { ModalCreateSignInUpComponent } from "@app/views/pages/sign-in-up/modal-create-sign-in-up/modal-create-sign-in-up.component";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
@Component({
	selector: "meu-app-activate-page",
	templateUrl: "./app-activate-page.component.html",
	styleUrls: ["./app-activate-page.component.scss"],
})
export class AppActivatePageComponent implements OnInit {
	constructor(
		private registeredUserService: RegisteredUserService,
		private toastr: ToastrService,
		private dialog: MatDialog,
		private router: Router,
	) { }
	isShow: boolean;
	ngOnInit() {
		this.activateAccountUser();
	}
	activateAccountUser() {
		let code = window.location.search.replace("?code=", "");
		this.registeredUserService
			.apiRegisteredUsersActivatePut(code)
			.subscribe((res) => {
				if (!res.success) {
					this.toastr.error(res.message);
					this.isShow = false;
				} else {
					this.isShow = true;
				}
			});
	}
	openModalSignIn() {
		this.dialog.open(ModalCreateSignInUpComponent, {
			width: "900px",
			data: { type: 'signin', returnUrl: location.pathname }
		});
	}
}
